import { ValidatorRuleType } from "@gaiaherbs/Common/Utilities/validate";

export const intialErrorFormState = {
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    state: "",
    phoneNumber: "",
    practiceType: "",
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q6: "",
};

export const practiceTypeOptions = [
    {
        value: "DC",
        label: "DC",
    },
    {
        value: "DDS",
        label: "DDS",
    },
    {
        value: "DO",
        label: "DO",
    },
    {
        value: "DTR",
        label: "DTR",
    },
    {
        value: "Health/Wellness Coach",
        label: "Health/Wellness Coach",
    },
    {
        value: "Herbalist",
        label: "Herbalist",
    },
    {
        value: "Lac",
        label: "Lac",
    },
    {
        value: "LMT",
        label: "LMT",
    },
    {
        value: "MD",
        label: "MD",
    },
    {
        value: "Midwife",
        label: "Midwife",
    },
    {
        value: "ND",
        label: "ND",
    },
    {
        value: "Nutritionist",
        label: "Nutritionist",
    },
    {
        value: "OMD",
        label: "OMD",
    },
    {
        value: "PA",
        label: "PA",
    },
    {
        value: "RD",
        label: "RD",
    },
    {
        value: "RN",
        label: "RN",
    },
    {
        value: "RPH",
        label: "RPH",
    },
    {
        value: "Student",
        label: "Student",
    },
];

export const interestedInGaiaHerbs = [
    {
        value: "personal use only",
        label: "Personal use only",
    },
    {
        value: "patients/clients only",
        label: "Patients/Clients only",
    },
    {
        value: "both personal and patients/clients",
        label: "Both",
    },
];

export const recommendationsOptions = [
    {
        value: "Dont recommend herbs to patients/clients",
        label: "Don't recommend herbs to patients/clients",
    },
    {
        value: "We sell in our office",
        label: "We sell in our office",
    },
    {
        value: "We refer patients/clients to a retail store",
        label: "We refer patients/clients to a retail store",
    },
    {
        value: "We refer patients/clients to an online shop",
        label: "We refer patients/clients to an online shop",
    },
    {
        value: "We use a patient drop ship or online patient dispensary program",
        label: "We use a patient drop ship or online patient dispensary program",
    },
    {
        value: "Combination- sell in office and use online patient dispensary program",
        label: "Combination- sell in office and use online patient dispensary program",
    },
];

export const refererOptions = [
    {
        value: "gaiaherbs.com",
        label: "gaiaherbs.com",
    },
    {
        value: "Social media",
        label: "Social media",
    },
    {
        value: "Webinar",
        label: "Webinar",
    },
    {
        value: "Trade Show",
        label: "Trade Show",
    },
    {
        value: "Google/Web search",
        label: "Google/Web search",
    },
    {
        value: "Other",
        label: "Other",
    },
];

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const newCustomerValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        label: "First Name",
    },
    lastName: {
        required: true,
        minLength: 2,
        label: "Last Name",
    },
    email: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "Email Address",
    },
    phoneNumber: {
        required: true,
        label: "Phone Number",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Phone Number",
    },
    practiceName: {
        required: false,
        label: "Practice Name",
    },
    practiceType: {
        required: true,
        label: "Practitioner Type",
    },
    country: {
        required: true,
        label: "Country Name",
    },
    state: {
        required: true,
        label: "State Name",
    },
    extension: {
        required: false,
        label: "Ext.",
    },
    q1: {
        required: true,
        label: "Are you interested in herbs for personal use or to recommend to patients/clients?",
    },
    q2: {
        required: true,
        label: "If you recommend herbs to patients/clients, how do they buy the herbs you recommend? Or if you are not currently using herbs with patients/clients, choose the option below that describes your intention for how to get herbs to them in the future.",
    },
    q3: {
        required: true,
        label: "Do you currently sell Gaia Herbs products?",
    },
    q4: {
        required: true,
        label: "School Attended?",
    },
    q5: {
        required: false,
        label: "If you attend conferences, please list them here:",
    },
    q6: {
        required: true,
        label: "How did you learn about us?",
    },
    notification: {
        required: false,
        label: "Receive emails regarding new research, published articles, new products, or conferences/lectures?",
    },
};
